// extracted by mini-css-extract-plugin
export var conversationListItem = "_z4-2";
export var fullBleedList = "_z4-3";
export var messageText = "_z4-1";
export var previewText = "_z4-0";